export default "__VITE_ASSET__d5b0ae0f__"